import store from '@/Store'

const setupApp = store.state.SetupApp

const detalheRedeCredenciada = async (idOperadora, idPrestador, espagr) => {
  let payload = {
    idOperadora: idOperadora,
    idPrestador: idPrestador,
    espagr: espagr ? 'S' : 'N'
  }

  const response = await setupApp.apiFuncionalidade.detalhePrestador({
    payload,
    loading: true,
    handlerErrorIgnore: [404, 400]
  })
  return response.data
}

const acionaFuncionalidade = async (req) => {
  const data = {
    type: 'texto',
    message: `${req.data.textoRedeCredenciadaChat}`
  }
  return { status: true, data, message: 'sucesso' }
}

export {
  detalheRedeCredenciada,
  acionaFuncionalidade
}
